import { render, staticRenderFns } from "./DodSettlementsList.vue?vue&type=template&id=79dc8f16&scoped=true&"
import script from "./DodSettlementsList.vue?vue&type=script&lang=js&"
export * from "./DodSettlementsList.vue?vue&type=script&lang=js&"
import style0 from "./DodSettlementsList.vue?vue&type=style&index=0&id=79dc8f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc8f16",
  null
  
)

export default component.exports